<!--
* @description  参数1
* @fileName  index
* @author userName
* @date 2024-03-04 09:34:16
!-->
<template>
  <div id="index" class="index">
    <div v-show="isAddPanle" class="mask" @click="()=>{isAddPanle=false}" />
    <div class="shipments">
      <div class="shipments-tab">
        <div
          v-for="(item,index) in tabList"
          :key="index"
          :class="['Company-Details',{'active':selectNumber == index}]"
          @click="clickType(item,index)"
        >
          {{ item.title }}({{ item.num }})
        </div>
        <div v-if="!isSearch" class="search-class" @click.stop="()=>{isSearch = true}"><img
          src="../../assets/img/manage/搜索@2x(1).png"
          width="20px"
          height="20px"
        ></div>
        <div
          v-show="isSearch"
          v-clickoutside="()=>{isSearch=false}"
          :class="{ 'order-search': true, 'order-search-active': inputStatus }"
          @mouseover="()=>{if(searchKey){search_btn = true}}"
          @mouseout="()=>{if(searchKey){search_btn = false}}"
        >
          <div
            class="order-search-input"
            @mouseenter="() => {
              if (searchKey) {
                deleteIcon = true
              }
            }"
            @mouseleave="() => {
              search_btn = false
              if (inputStatus&&searchKey.length) {
                deleteIcon = true
              }else{
                deleteIcon = false
              }
            }"
          >
            <input
              ref="orderSearchInput"
              v-model="searchKey"
              type="text"
              class="order-search-input__inner"
              :placeholder="'Search something…'"
              maxlength="20"
              @focus="focusInput"
              @blur="blurInput"
              @keydown.enter="submitSearch"
            >
            <div class="delete-icon" @click.stop="()=>{searchKey=''}">
              <transition name="shanchu">
                <img
                  v-show="deleteIcon"
                  src="../../assets/img/manage/del_icon.png"
                  width="16px"
                  height="16px"
                >
              </transition>
            </div>
          </div>
          <div :class="['order-search-btn',search_btn?'search_btnhover':'']" @click="submitSearch">
            <img src="../../assets/img/manage/搜索@2x(1).png" width="20px" height="20px">
          </div>
        </div>
      </div>
      <div class="shipments-right-main">
        <div class="shipments-right">
          <div :class="{'add-active':isAddPanle}" style="cursor: pointer;" @click="clickAdd()">Add/Remove
            columns</div>
          <div style="cursor: pointer;" @click="exportBill">Export to CSV</div>
        </div>
        <div v-if="isAddPanle" class="columns-panle">
          <vuedraggable v-model="columeList" class="wrapper" @update="updateSort">
            <template v-for="(item,index) in columeList">
              <div
                :key="index"
                :class="['list-item']"
                style="cursor: pointer;"
                @click="activeList(item,index)"
              >
                <div :class="item.isSelected ?'choose-icon-active':'choose-icon'" />
                <span>{{ item.value }}</span>
              </div>
            </template>
          </vuedraggable>
        </div>
      </div>
    </div>
    <div class="table-main">
      <Table ref="Table" />
    </div>
  </div>
</template>

<script>
import vuedraggable from 'vuedraggable'
import Table from './Table.vue'
import request from '@/utils/request'
import {
  ExportBill
} from '@/api/user.js'
import {
  getCookie
} from '@/utils/cookiejs'
export default {
  name: 'Index',
  components: {
    // 组件的引用
    Table,
    vuedraggable
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      isSearch: false,
      inputStatus: false, // 输入框状态
      searchKey: '', // 搜索关键词
      search_btn: false,
      deleteIcon: false, // 删除按钮
      isAddPanle: false,
      columeList: [{
        'field': 'statusStr',
        'value': 'Payment Status',
        'isSelected': true,
        'sortable': true,
        'type': 'input',
        'width': 180,
        'fixed': false
      }, {
        'field': 'billNo',
        'value': 'Proforma Invoice',
        'isSelected': true,
        'width': 200,
        'fixed': false
      }, {
        'field': 'orderName',
        'value': 'Related Shipment',
        'isSelected': true,
        'width': 200,
        'fixed': false,
        'isLink': true
      }, {
        'field': 'orderNo',
        'value': 'Shipment #',
        'isSelected': false,
        'width': 200,
        'fixed': false
      }, {
        'field': 'mode',
        'value': 'Mode',
        'isSelected': false,
        'width': 200,
        'fixed': false
      }, {
        'field': '',
        'value': 'Commodity',
        'isSelected': false,
        'width': 200,
        'fixed': false
      }, {
        'field': 'carrierName',
        'value': 'Carrier',
        'isSelected': false,
        'width': 200,
        'fixed': false
      }, {
        'field': 'horder',
        'value': 'HAWB / HBOL',
        'isSelected': false,
        'width': 120,
        'fixed': false
      }, {
        'field': 'morder',
        'value': 'MAWB / MBOL',
        'isSelected': false,
        'width': 150,
        'fixed': false
      }, {
        'field': 'vessel',
        'value': 'Vessel / Flight',
        'isSelected': false,
        'width': 200,
        'fixed': false
      }, {
        'field': 'container',
        'value': 'Container #',
        'isSelected': false,
        'width': 150,
        'fixed': false
      }, {
        'field': 'billStatusStr',
        'value': 'Shipment Status',
        'isSelected': false,
        'width': 150,
        'fixed': false
      }, {
        'field': 'updateTimeStr',
        'value': 'Status Date',
        'isSelected': false,
        'width': 200,
        'fixed': false
      }, {
        'field': 'creatorTimeStr',
        'value': 'Invoice Date',
        'isSelected': true,
        'width': 200,
        'fixed': false
      }, {
        'field': 'dueTimeStr',
        'value': 'Due Date',
        'isSelected': true,
        'width': 200,
        'fixed': false
      }, {
        'field': 'currency',
        'value': 'Currency',
        'isSelected': true,
        'width': 150,
        'fixed': false
      }, {
        'field': 'totalCost',
        'value': 'Invoice Amount',
        'isSelected': true,
        'width': 150,
        'fixed': false
      }, {
        'field': 'totalPaid',
        'value': 'Amount Paid',
        'isSelected': true,
        'width': 150,
        'fixed': false
      }, {
        'field': 'totalDue',
        'value': 'Amount Due',
        'isSelected': true,
        'width': 180,
        'fixed': false
      }],
      token: '',
      tabList: [{
        title: 'Due Payment',
        num: 0
      },
      {
        title: 'Pending transfer',
        num: 0
      },
      {
        title: 'Open',
        num: 0
      },
      {
        title: 'All',
        num: 0
      }
      ],
      selectNumber: 0,
      deatilsPath: '/customer/deatils', // 表格当前行跳转路径
      tableList: [{
        id: 0,
        name: 'name',
        label: '姓名',
        type: 'text',
        param: '',
        isShow: true,
        exp: '',
        extra: {
          icon: 'file-list-line'
        }
      },
      {
        id: 0,
        name: 'name',
        label: '姓名',
        type: 'text',
        param: '',
        isShow: true,
        exp: '',
        extra: {
          icon: 'file-list-line'
        }
      }
      ]
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  mounted() {
    // 页面进入时加载内容
  },
  created() {
    // 实例被创建之后执行代码
    this.token = getCookie('token')
    if (this.token) {
      this.getOrderInfo()
      localStorage.setItem('columeList-billing', JSON.stringify(this.columeList))
    }
  },
  methods: {
    updateSort() {
      localStorage.removeItem('columeList-billing')
      localStorage.setItem('columeList-billing', JSON.stringify(this.columeList))
      this.$nextTick(() => {
        this.$refs.Table.updateSort()
      })
    },
    exportBill() {
      ExportBill({
        status: this.selectNumber + 1,
        keywords: this.searchKey
      }).then(res => {
        if (res.code === 200) {
          this.xms.downloadFile(res.data.url)
        }
      })
    },
    clickAdd() {
      this.isAddPanle = true
    },
    activeList(item, index) {
      item.isSelected = !item.isSelected
      localStorage.removeItem('columeList-billing')
      localStorage.setItem('columeList-billing', JSON.stringify(this.columeList))
      this.$nextTick(() => {
        this.$refs.Table.updateSort()
      })
    },
    focusInput() {
      this.inputStatus = true
      // 选中文本
      this.$refs.orderSearchInput.select()
      if (this.searchKey.length > 0) {
        this.deleteIcon = true
      }
    },
    blurInput() {
      this.inputStatus = false
      this.deleteIcon = false
    },
    submitSearch() {
      this.searchKey = this.searchKey.trim()
      this.getOrderInfo(this.searchKey)
      this.$nextTick(() => {
        this.$refs.Table.search(this.searchKey)
      })
    },
    // 清除input值
    clearInput() {
      this.searchKey = ''
    },
    clickType(item, index) {
      this.selectNumber = index
      this.$nextTick(() => {
        this.$refs.Table.change(index + 1)
      })
    },
    getOrderInfo(keywords) {
      request({
        url: `/api/fin/FinancialCosts/GetCustomerOrderBill`,
        method: 'GET',
        data: {
          keywords: keywords,
          pageSize: 99999
        },
        headers: {
          Authorization: this.token
        }
      }).then(res => {
        if (res.data != null) {
          this.tabList[3].num = res.data.list.filter(order => order.statusName != '').length
          this.tabList[0].num = res.data.list.filter(order => order.statusStr === 'Due Payment').length
          this.tabList[1].num = res.data.list.filter(order => order.statusStr === 'Pending transfer')
            .length
          this.tabList[2].num = res.data.list.filter(order => order.statusStr === 'Open').length
        }
      })
    }
  }
}
</script>
<style scoped lang='scss'>
	.mask {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 100;
	}

	.shipments {
		display: flex;
		justify-content: space-between;

		.shipments-tab {
			display: flex;
			justify-content: start;

			.active {
				max-width: 150px;
				min-width: 59px;
				height: 32px;
				line-height: 32px;
				background: #FFFFFF;
				border-radius: 6px;
				font-size: 16px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				color: #E95506 !important;
				padding: 0 8px;
			}

			.Company-Details,
			.Users {
				font-size: 16px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				color: #777777;
				margin-right: 16px;
				line-height: 32px;
				cursor: pointer;
			}

			.search-class {
				width: 32px;
				height: 32px;
				background: #E95506;
				border-radius: 8px;
				line-height: 32px;
				color: #FFFFFF;

				&:hover {
					background: #EE7D41;
				}

				display: flex;
				align-items: center;
				justify-content: center;
				cursor: pointer;
			}

			.order-search {
				display: flex;
				align-items: center;
				width: 240px;
				height: 32px;
				padding: 0 3px 0 12px;
				background: #FFFFFF;
				border-radius: 8px;
				border: 1px solid #EE7D41;
				position: relative;
				box-sizing: border-box;
				transition: border 0.2s ease-in-out, box-shadow 0.2s ease-in-out;

				&:hover {
					background: #ffffff;
					transition: all 0.2s;

					.order-search-input .order-search-input__inner {
						background: #ffffff;
						transition: all 0.2s;
					}
				}

				.order-search-input {
					position: relative;

					.order-search-input__inner {
						width: 170px;
						height: 18px;
						padding: 6px 0;
						font-size: 13px;
						font-family: PingFangSC-Medium, PingFang SC;
						font-weight: 500;
						color: #333333;
						line-height: 18px;
						outline: none;
						border: none;

						&::-webkit-input-placeholder {
							font-size: 13px;
							font-family: PingFangSC-Regular, PingFang SC;
							font-weight: 400;
							color: #aaaaaa;
							line-height: 18px;
						}
					}

					.delete-icon {
						position: absolute;
						width: 20px;
						height: 16px;
						top: 8px;
						right: -20px;
						cursor: pointer;
						z-index: 9999;
						display: flex;
						align-items: center;

					}
				}

				.order-search-btn {
					position: absolute;
					right: 0px;
					width: 32px;
					height: 32px;
					background: #E95506;
					border-radius: 8px;
					line-height: 32px;
					color: #FFFFFF;

					&:hover {
						background: #EE7D41;
					}

					display: flex;
					align-items: center;
					justify-content: center;
					cursor: pointer;
				}
			}
		}

		.shipments-right-main {
			position: relative;

			.shipments-right {
				float: right;
				display: flex;

				div {
					height: 32px;
					line-height: 32px !important;
					background: rgba(233, 85, 6, 0);
					border-radius: 8px;
					border: 1px solid #E95506;
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					font-size: 14px;
					color: #E95506;
					line-height: 20px;
					text-align: center;
				}

				.add-active {
					background: rgba(233, 85, 6, 0.08);
				}

				div:nth-of-type(1) {
					width: 176px;
					margin-right: 16px;
				}

				div:nth-of-type(2) {
					width: 120px;
				}
			}

			.columns-panle {
				width: 200px;
				height: auto;
				background: #FFFFFF;
				box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.04);
				border-radius: 8px;
				border: 1px solid rgba(221, 221, 221, 0.56);
				position: absolute;
				z-index: 100;
				top: 35px;
				padding: 6px 0;

				.list-item {
					height: 33px;
					line-height: 33px;
					background: rgba(255, 255, 255, 0);
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 13px;
					color: #333333;
					line-height: 22px;
					text-align: left;
					display: flex;
					align-items: center;
					padding-right: 12px;

					&:hover {
						background: #F2F4F8;

						.img_icon {
							background: url('../../assets/img/manage/settings/a_1.jpg');
							width: 16px;
							height: 16px;
							background-size: 16px 16px;
							margin-left: auto;
						}
					}

					.img_icon {
						&:active {
							background: url('../../assets/img/manage/settings/a_2.jpg');
							width: 16px;
							height: 16px;
							background-size: 16px 16px;
							margin-left: auto;
						}
					}

					.img_icon {
						background: url('../../assets/img/manage/settings/a_1.jpg');
						width: 16px;
						height: 16px;
						background-size: 16px 16px;
						margin-left: auto;
					}

					.choose-icon {
						width: 16px;
						height: 16px;
						background: #FFFFFF;
						border-radius: 4px;
						border: 1px solid #CCCCCC;
						margin: 16px 8px 16px 16px;
						box-sizing: border-box;
					}

					.choose-icon-active {
						background: url('../../assets/img/client/icon_success.png');
						background-size: 16px 16px;
						width: 16px;
						height: 16px;
						margin: 16px 8px 16px 16px;
					}
				}
			}
		}
	}

	.table-main {
		background: #FFFFFF;
		border-radius: 8px;
		padding: 24px;
		margin-top: 16px;
	}
</style>
